/** Resuelve si la venta tiene imputaciones customer (local, remoto o totales). */
export function resolveHasCustomerAllocations(params: {
  allocationCount: number;
  detailHasCustomerAllocations?: boolean;
  customerAllocationPaidFromTotals: number;
  detailCustomerAllocationPaid?: number;
}): boolean {
  return (
    params.allocationCount > 0 ||
    params.detailHasCustomerAllocations === true ||
    params.customerAllocationPaidFromTotals > 0 ||
    (params.detailCustomerAllocationPaid ?? 0) > 0
  );
}
